import styled from '@emotion/styled';
import Park from './card/park';
import Shin from './card/shin';
import Kim from './card/kim';

const Card:React.FC<any> = () => {

  return (
    <Container>
      <TextContainer>
        <BoldText>
          내돈내산<br/>
          12개월 구독이야기
        </BoldText>
        <SmallText>
          대기업 디자이너부터<br/>
          육아휴직 육아맘까지
        </SmallText>
      </TextContainer>
      <ImgContainer>
        <Img src="/images/klikkie/main/blog.png"/>
      </ImgContainer>
      <ReviewContainer>
        <Park />
        <Shin/>
        <Kim />
      </ReviewContainer>
    </Container>
  )
};

export default Card;

const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const ReviewContainer = styled.div`
  /* margin-top: 60px; */
  display: flex;
  flex-direction: column;
`

const TextContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin: 100px auto 40px;
`

const BoldText = styled.div`  
  display: flex;
  margin: 0 auto;
  text-align: center;
  font-weight: bold;
  font-size: 30px;
  line-height: 1.3;
`;

const SmallText = styled.div`
  font-size: 16px;
  display: flex;
  justify-content: center;
  text-align: center;
  margin-top: 20px;
`;

const ImgContainer = styled.div`
  height: 40px;
  margin: 0 auto 120px;
`

const Img = styled.img`
  height: 100%;
`